<template>
	<div class="sb">
		<van-sticky>
			<div class="rcst_sc">
				<div class="rcst_sc_drop">
					<div @click="backPrev()" class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
					<van-dropdown-menu active-color="#FB8027">
						<van-dropdown-item v-model="cur_city" @change="selectDropdown" :options="cur_city_list" />
					</van-dropdown-menu>
				</div>
				<div class="rcst_date">
					<div v-for="(std_item,std_index) in date_list" :key="std_item.timp"
						:class="[{'rcst_date_itemS':date_index==std_index},'rcst_date_item']"
						@click="selectSportTypeDate(std_index)">
						<div>
							<div class="rcst_date_item_1">{{std_item.week_show}}</div>
							<div class="rcst_date_item_2">{{std_item.date}}</div>
						</div>
					</div>
				</div>
			</div>
		</van-sticky>
		<div class="spl2">
			<div class="sl6">
			    <div v-for="(item,index) in course_list" :key="index" class="sl6_item" :style="'background-image: url('+item.thumb+');'">
			        <div class="sl6_item_head">
			            <div class="sl6_item_head_1">
			                <div>{{item.venue_name}}</div>
			            </div>
						<div class="sl6_item_head_2"></div>
			        </div>
			        <div @click="getStocks(item)" class="sl6_item_body">
			            <div class="sl6_item_body_coach">
			                <!-- <image class="sl6_item_body_coach_avatar" src="{{sl6_item.coach_head_picture}}" mode="aspectFit"/> -->
							<img class="sl6_item_body_coach_avatar" :src="item.coach_head_picture" alt="" />
			                <div class="sl6_item_body_coach_body">
			                    <div class="sl6_item_body_coach_body_name font_weight_600">{{item.coach_name}}</div>
			                    <div class="sl6_item_body_coach_body_tag">
			                        <div v-for="(item_g,index_g) in item.coach_good_at_desc">{{item_g}}</div>
			                    </div>
			                </div>
			            </div>
			            <div class="sl6_item_body_body">
			                <div class="sl6_item_body_body_left">
			                    <div class="sl6_item_body_body_left_1 font_weight_600">
			                        {{item.course_name}}
			                        <div v-if="item.earliest_begin_time_txt">{{item.earliest_begin_time_txt}}</div>
			                    </div>
			                    <div class="sl6_item_body_body_left_2">
			                        <div class="sl6_item_body_body_left_2_item">
			                            <div class="sl6_item_body_body_left_2_1">¥</div>
			                            <div class="sl6_item_body_body_left_2_2">{{item.course_price}}</div>
			                            <div class="sl6_item_body_body_left_2_3">/课时</div>
			                        </div>
			                    </div>
			                </div>
			                <div v-if="!item.earliest_begin_time_txt" class="sl6_item_body_body_btn sl6_item_body_body_btnN">已约满</div>
			                <div v-else class="sl6_item_body_body_btn">预约</div>
			            </div>
			        </div>
			    </div>
			</div>
		</div>
		
		<van-popup v-model="pop_time" closeable position="bottom" @click-overlay="pop_time=false"
		style="background:#fff;" catchtouchmove="ture">
		  <div class="sl6_pop">
		    <div class="sl6_pop_block">
		        <div class="sl6_pop_block_title font_weight_600">选择时间</div>
		        <div class="sl6_pop_block_body">
		            <van-row gutter="12">
		                <van-col span="8" v-for="(sl7p_item,sl7p_index) in can_book_time" :key="sl7p_item.course_timetable_id">
		                    <div @click="selectBookTime(sl7p_item,sl7p_index)" 
							 :class="[{'sl6_pop_block_body_item_mag':sl7p_index>2},{'sl6_pop_block_body_itemS':can_book_time_index==sl7p_index},{'sl6_pop_block_body_itemN':sl7p_item.status!='AVAILABLE'},'sl6_pop_block_body_item']"
							 >
							{{sl7p_item.time_txt}}
							</div>
		                </van-col>
		            </van-row>
		        </div>
		        <div class="sl6_pop_block_btn font_weight_600">
		            <div @click="toCreateOrder()" :class="[{'sl6_pop_block_btn_btnS':can_book_time_index>-1},'sl6_pop_block_btn_btn']">预约</div>
		        </div>
		    </div>
		  </div>
		</van-popup>

	</div>
</template>

<script>
	import {
		futureTimesGroup,
		datePrintStr2,
	} from "../../lib/utils.js"
	export default {
		data() {
			return {
				cur_city: '',
				cur_city_list: [],

				date_list: futureTimesGroup(7),
				date_index: 0,

				venus_list: [],
				
				class_id:'',
				
				course_list:[],
				
				pop_time:false,
				can_book_time:[],
				can_book_time_index:-1,
				select_course_time:null,
				select_course:null
			}
		},
		created() {
			
			// console.log(futureTimesGroup(8).shift());
			// console.log(futureTimesGroup(8));
			var ttt=futureTimesGroup(8)
			ttt.shift()
			// console.log(ttt);
			this.date_list=ttt
			
			console.log(this.$route.params.class_id);
			this.class_id=this.$route.params.class_id
			document.title='五星酒店健身私教'

			this.getCity()
		},
		mounted() {},
		methods: {
			toCreateOrder(){
				if(localStorage.getItem('token') && localStorage.getItem('phone')){
					console.log(this.select_course);
					console.log(this.select_course_time);
					// console.log();
					var date=this.select_course_time.begin_time.substring(0,10)
					// console.log(date);
					// // :course_timetable_id/:date/:time',
					// return
					this.$router.push({
						name:'venue_goods_createorder2',
						params: {
							course_timetable_id:this.select_course_time.course_timetable_id,
							date: date,
							time:this.select_course_time.time_txt,
							venue_name:this.select_course.venue_name,
							course_name:this.select_course.course_name
						}
					})
				}else{
					var params={
						course_timetable_id:this.select_course_time.course_timetable_id,
						date: date,
						time:this.select_course_time.time_txt,
						venue_name:this.select_course.venue_name,
						course_name:this.select_course.course_name
					}
					localStorage.removeItem('dparams')
					localStorage.setItem('dparams2',JSON.stringify(params))
					this.$router.push({
						name: 'venue_goods_login',
					})
				}
				
				// /:venue_name/:course_name
			},
			selectBookTime(item,index){
				if (item.status == 'AVAILABLE') {
					this.can_book_time_index=index
					this.select_course_time=item
				}
			},
			closePop(){
				this.pop_time=!this.pop_time
			},
			backPrev(){
				this.$router.go(-1)
			},
			getCity() {
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.demo1_cityList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						var cur_city = res.data[0]
						var cur_city_list = []
						res.data.map((item) => {
							var param = {
								text: item,
								value: item
							}
							cur_city_list.push(param)
						})
						$this.cur_city = res.data[0]
						$this.cur_city_list = cur_city_list
						$this.getVenusList()
					}).catch((error) => {
						console.warn(error)
						$this.$toast('网络异常');
					})
			},
			getVenusList() {
				var $this = this
				var param = {
					city:this.cur_city,
					date:this.date_list[this.date_index].nyr_heng,
					class_id:this.class_id,
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getCourseList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						$this.course_list=res.data
					}).catch((error) => {
						console.warn(error)
						$this.$toast('网络异常');
					})
			},
			toDetail(item) {
				console.log('库存+下单');
			},
			selectSportTypeDate(e) {
				this.date_index = e
				this.getVenusList()
			},
			selectDropdown(e) {
				console.log(e);
				this.cur_city = e
				this.getVenusList()
			},
			getStocks(e){
				var $this = this
				console.log(e);
				if(!e.earliest_begin_time_txt){
					return
				}
				this.$loading('正在加载中...');
				
				var param = {
					goods_id: e.course_goods_id,
					date: this.date_list[this.date_index].nyr_heng,
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getCourseGoodsTimetablesByDate
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						
						if(res.code==200){
							if (res.data && res.data.length > 0) {
								$this.can_book_time=res.data
								$this.can_book_time_index=-1
								$this.select_course_time=null
								$this.select_course=e
							    // $this.setData({
							    //     can_book_time: res.data,
							    //     can_book_time_index: -1,
							    //     select_course_time: null,
							    //     select_course: e.currentTarget.dataset.item
							    // }, () => {
							    //     $this.openSelectTime()
							    //     wx.hideLoading()
							    // })
								$this.closePop()
								$this.$loading.close();
							} else {
								$this.$loading.close();
							    wx.showToast({
							        title: '暂无排课~',
							        icon: 'none',
							        mask: true
							    })
							}
						}else{
							$this.$loading.close();
						}
					}).catch((error) => {
						$this.$loading.close();
						console.warn(error)
						$this.$toast('网络异常');
					})
				// 
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.sb{
		width: 100%;
		min-height: 100vh;
		background-color: #fff;
	}

	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;

		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			padding: 0 30*@vm_base;
			// border: 1*@vm_base solid red;
			.rcst_sc_drop_left{
				width: 60*@vm_base;
				height: 100%;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}

		.rcst_date {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 30*@vm_base;
		}

		.rcst_date_item {
			width: 80*@vm_base;
			height: 92*@vm_base;
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			color: #666666;
			border: 1*@vm_base solid #fff;
		}

		.rcst_date_itemS {
			border: 1*@vm_base solid #F77F28;
			color: #F77F28;
		}

		.rcst_date_item_1 {
			font-size: 20*@vm_base;
		}

		.rcst_date_item_2 {
			font-weight: bold;
			font-size: 30*@vm_base;
			margin-top: 6*@vm_base;
		}
	}

	.spl2{
		width: 100%;
		// border: 1*@vm_base solid red;
		padding: 30*@vm_base 0;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
		
		.sl6{
		    width: 100%;
		    padding: 0 30*@vm_base 30*@vm_base 30*@vm_base;
		}
		.sl6_item{
		    width: 100%;
		    background: #F6F7F9;
		    border-radius: 8*@vm_base;
		    margin-bottom: 30*@vm_base;
		    background-repeat: no-repeat;
		    background-position: top center;
		    background-size: 100%;
		}
		.sl6_item:last-child{
		    margin-bottom: 0;
		}
		.sl6_item_head{
		    width: 100%;
		    white-space: nowrap;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    padding: 0 20*@vm_base;
		    border-bottom: 1*@vm_base solid #D9D9D9;
		}
		.sl6_item_head_1{
		    width: fit-content;
		    max-width: calc(100% - 160*@vm_base);
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    font-size: 24*@vm_base;
		    color: #666666;
		    padding-right: 24*@vm_base;
		    background-size: auto 100%;
		    background-repeat: no-repeat;
		    background-position: right center;
		    // background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20250313_aiIGijAAMgUdXX0.png);
		}
		.sl6_item_head_1 div{
		    width: fit-content;
		    max-width: 100%;
		    white-space: nowrap;
		    overflow: hidden;
		    text-overflow: ellipsis;
		}
		.sl6_item_head_2{
		    width: fit-content;
		    white-space: nowrap;
		    height: 66*@vm_base;
		    display: flex;
		    font-size: 24*@vm_base;
		    color: #999999;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    line-height: 1.3;
		}
		.sl6_item_head_2 image{
		    width: 26*@vm_base;
		    height: 26*@vm_base;
		    margin-right: 6*@vm_base;
		}
		.sl6_item_body{
		    width: 100%;
		    padding: 20*@vm_base;
		}
		.sl6_item_body_coach{
		    width: fit-content;
		    max-width: 100%;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		}
		.sl6_item_body_coach_avatar{
		    width: 100*@vm_base;
		    border-radius: 16*@vm_base;
		}
		.sl6_item_body_coach_body{
		    width: fit-content;
		    max-width: calc(100% - 120*@vm_base);
		    margin-left: 20*@vm_base;
		}
		.sl6_item_body_coach_body_name{
		    width: fit-content;
		    max-width: 100%;
		    white-space: nowrap;
		    overflow: hidden;
		    text-overflow: ellipsis;
		    font-size: 28*@vm_base;
		    color: #333333;
		}
		.sl6_item_body_coach_body_tag{
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    margin-top: 16*@vm_base;
		    overflow: hidden;
		    width: fit-content;
		    max-width: 100%;
		}
		.sl6_item_body_coach_body_tag div{
		    width: fit-content;
		    white-space: nowrap;
		    background: rgba(247,127,40,0.1);
		    border-radius: 20*@vm_base;
		    padding: 5*@vm_base 17*@vm_base;
		    margin-right: 10*@vm_base;
		    font-size: 24*@vm_base;
		    color: #666666;
		}
		.sl6_item_body_coach_body_tag div:last-child{
		    margin-right: 0;
		}
		.sl6_item_body_body{
		    width: 100%;
		    background: rgba(255,255,255,0.8);
		    border-radius: 8*@vm_base;
		    margin-top: 20*@vm_base;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    padding: 20*@vm_base;
		}
		.sl6_item_body_body_left{
		    width: calc(100% - 180*@vm_base);
		}
		.sl6_item_body_body_left_1{
		    font-size: 28*@vm_base;
		    color: #333333;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		}
		.sl6_item_body_body_left_1 div{
		    font-size: 24*@vm_base;
		    color: #666666;
		    padding-left: 20*@vm_base;
		}
		.sl6_item_body_body_left_2{
		    display: flex;
		    justify-content: flex-start;
		    align-items:flex-end;
		    margin-top: 20*@vm_base;
		}
		.sl6_item_body_body_left_2_item{
		    display: flex;
		    justify-content: center;
		    align-items: flex-end;
		}
		.sl6_item_body_body_left_2_1{
		    font-size: 24*@vm_base;
		    color: #F77F28;
		    line-height: 1.1;
		    margin-right: 4*@vm_base;
		}
		.sl6_item_body_body_left_2_2{
		    font-size: 44*@vm_base;
		    color: #F77F28;
		}
		.sl6_item_body_body_left_2_3{
		    font-size: 24*@vm_base;
		    color: #666666;
		    line-height: 1.1;
		    margin-left: 4*@vm_base;
		}
		.sl6_item_body_body_btn{
		    width: 170*@vm_base;
		    height: 60*@vm_base;
		    background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
		    border-radius: 50*@vm_base;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 26*@vm_base;
		    color: #FFFFFF;
		}
		.sl6_item_body_body_btnN{
		    background: #D9D9D9;
		    color: #999999;
		}
		
		
		
		
	}
	.sl6_pop{
	    width: 100%;
	    // padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 104*@vm_base);
	    // padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 104*@vm_base);
		.sl6_pop_block{
		    width: 100%;
		    padding: 40*@vm_base 30*@vm_base;
		}
		.sl6_pop_block_title{
		    font-size: 32*@vm_base;
		    color: #333333;
		}
		.sl6_pop_block_body{
		    width: 100%;
		    padding: 30*@vm_base 0 60*@vm_base 0;
		}
		.sl6_pop_block_body_item{
		    width: 100%;
		    height: 72*@vm_base;
		    border-radius: 10*@vm_base;
		    border: 1*@vm_base solid #D9D9D9;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 26*@vm_base;
		    color: #333333;
		}
		.sl6_pop_block_body_itemN{
		    border: 1*@vm_base solid #D9D9D9;
		    color: #D9D9D9;
		}
		.sl6_pop_block_body_itemS{
		    background: linear-gradient( 145deg, #FFA662 0%, #FA7D23 100%);
		    color: #FFFFFF;
		    border: 1*@vm_base solid transparent;
		}
		.sl6_pop_block_body_item_mag{
		    margin-top: 20*@vm_base;
		}
		.sl6_pop_block_btn{
		    width: 100%;
		    padding: 0 45*@vm_base;
		}
		.sl6_pop_block_btn_btn{
		    width: 100%;
		    height: 80*@vm_base;
		    background: #D9D9D9;
		    border-radius: 50*@vm_base;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 32*@vm_base;
		    color: #FFFFFF;
		}
		.sl6_pop_block_btn_btnS{
		    background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
		}
	}
	
	.spl {
		width: 100%;
		background-color: #FFFFFF;
		padding: 2*@vm_base 30*@vm_base 20*@vm_base 30*@vm_base;
		color: #000;

		.spl_block {
			width: 100%;
			background: rgba(246, 247, 249, 1);
			border-radius: 16*@vm_base;
			margin-bottom: 20*@vm_base;
		}

		.spl_block:last-child {
			margin-bottom: 0;
		}

		.spl_block_pic {
			width: 100%;
			height: 414*@vm_base;
			border-radius: 16*@vm_base;
			background-position: top center;
			background-repeat: no-repeat;
			background-size: 100%;
			position: relative;
			overflow: hidden;
		}

		/* .spl_block_pic_bvip{
		  width: fit-content;
		  white-space: nowrap;
		  height: 50*@vm_base;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  padding: 0 20*@vm_base;
		  background: linear-gradient( 90deg, #FAE9D2 0%, #F3CFA6 100%);
		  border-radius:0 0 16*@vm_base 0;
		  font-size: 26*@vm_base;
		  color: #333333;
		} */
		.spl_block_pic_logo {
			position: absolute;
			top: 0;
			right: 0;
			width: 80*@vm_base;
			height: 80*@vm_base;
			margin-top: 20*@vm_base;
			margin-right: 20*@vm_base;
		}

		.spl_block_pic_recomm {
			position: absolute;
			bottom: 0;
			left: 0;
			padding: 20*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.spl_block_pic_recomm_item {
			width: fit-content;
			margin-right: 20*@vm_base;
			font-weight: 500;
			font-size: 20*@vm_base;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.spl_block_pic_recomm_item_cricle {
			width: 40*@vm_base;
			height: 40*@vm_base;
			background: rgba(255, 255, 255, 0.4);
			border-radius: 50%;
			margin-right: 6*@vm_base;
			background-size: 26*@vm_base;
			background-repeat: no-repeat;
			background-position: center;
		}

		.spl_block_pic_recomm_item_cricle_hot {
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240409_BUCoPFs538RkXOD.png);
		}

		.spl_block_pic_recomm_item_cricle_rec {
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240409_i4DXiGJB32TKUpu.png);
		}

		.spl_block_block {
			width: 100%;
			padding: 30*@vm_base 20*@vm_base 20*@vm_base 20*@vm_base;
			position: relative;
		}

		.spl_block_block_title {
			width: calc(100% - 200*@vm_base);
			font-weight: 600;
			font-size: 36*@vm_base;
			color: #333333;
			line-height: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.spl_block_block_distance {
			width: 100%;
			margin-top: 20*@vm_base;
			font-weight: 500;
			font-size: 24*@vm_base;
			color: #999999;
			line-height: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			padding-left: 36*@vm_base;
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240529_m6K3irKkqOLCOKu.png);
			background-size: auto 98%;
			background-position: left bottom;
			background-repeat: no-repeat;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.spl_block_block_distance div {
			width: 200*@vm_base;
			text-align: center;
			color: #FF4600;
		}

		.spl_block_block_cont {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-top: 6*@vm_base;
		}

		.spl_block_block_cont_btn {
			position: absolute;
			bottom: 30*@vm_base;
			right:30*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 200*@vm_base;
			height: 64*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 32*@vm_base;
			font-weight: 500;
			font-size: 30*@vm_base;
			color: #FFFFFF;
		}

		.spl_block_block_cont_btnN {
			background: rgba(0, 0, 0, 0.4);
		}

		.spl_block_block_cont_price {
			display: flex;
			justify-content: center;
			align-items: flex-end;
		}

		.spl_block_block_cont_price_1 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #F77F28;
			line-height: 1.5;
		}

		.spl_block_block_cont_price_2 {
			/* font-weight: 500; */
			font-size: 52*@vm_base;
			color: #F77F28;
			line-height: 1;
		}

		.spl_block_block_cont_price_3 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #F77F28;
			line-height: 1.5;
		}

		.spl_block_block_cont_price_4 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #999999;
			line-height: 1.5;
			margin-left: 20*@vm_base;
			text-decoration: line-through;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/list2.vue